/* ============================================================
   glow-cart-gate.js — משלים ה-JS לשער "זוג ומעלה" של Glow.
   הליבה (חישוב/הודעה/מצב-כפתור) חיה ב-Liquid ומתרנדרת ב-section-render
   באותו frame כמו המחיר. ה-JS כאן משלים רק את מה ש-Liquid לא שולט בו:
   (א) הסתרת dynamic checkout buttons (Shop Pay/Google Pay — iframe אסינכרוני)
   (ב) חגורה-ושלייקס: אכיפת disabled על כפתור ה-checkout הרגיל אחרי merge,
       למקרה ש-section-render לא נגע בו (בעמוד cart הכפתור מחוץ ל-data-merge).
   (ג) אכיפת-קליק: preventDefault על קליק ב-checkout כשהשער חסום. ב-drawer
       הכפתור הוא <a aria-disabled tabindex="-1"> — <a> עם aria-disabled עדיין
       קליקבילי טכנית; ה-CSS (pointer-events:none) חוסם, וזה הגיבוי ברמת ה-JS
       לחלון שלפני החלת ה-CSS ולהפעלה תכנותית (el.click()).
   מגיב ל-event הסינכרוני on:cart:after-merge — אין setTimeout/delay.
   ============================================================ */
(function () {
  'use strict';

  var GATE_SOURCE = '[data-glow-gate-state]';
  var DYNAMIC_SELECTORS = [
    '.additional-checkout-buttons',
    '.shopify-payment-button',
    '.dynamic-checkout__content'
  ];

  /* קורא את מצב השער מה-DOM (ה-Liquid רינדר data-glow-gate-state בתוך אזור
     ממוזג). מחזיר true אם חסום. אם אין מקור (עגלה ריקה) — לא חסום. */
  function isBlocked(root) {
    var source = root.querySelector(GATE_SOURCE);
    if (!source) return false;
    return source.getAttribute('data-glow-gate-state') === 'blocked';
  }

  /* מיישם את מצב השער על cart-form יחיד: כפתור checkout + dynamic buttons. */
  function applyGate(cartForm) {
    if (!cartForm) return;
    var blocked = isBlocked(cartForm);

    var container = cartForm.querySelector('[data-glow-gate]');
    if (container) {
      container.setAttribute('data-glow-gate', blocked ? 'blocked' : 'ok');
      container.classList.toggle('glow-checkout--blocked', blocked);
    }

    var checkoutBtn = cartForm.querySelector('.glow-checkout-btn');
    if (checkoutBtn) {
      if (checkoutBtn.tagName === 'BUTTON') {
        checkoutBtn.disabled = blocked;
      }
      if (blocked) {
        checkoutBtn.setAttribute('aria-disabled', 'true');
        checkoutBtn.setAttribute('tabindex', '-1');
      } else {
        checkoutBtn.removeAttribute('aria-disabled');
        checkoutBtn.removeAttribute('tabindex');
      }
    }

    for (var i = 0; i < DYNAMIC_SELECTORS.length; i += 1) {
      var nodes = cartForm.querySelectorAll(DYNAMIC_SELECTORS[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        nodes[j].classList.toggle('glow-dynamic-hidden', blocked);
      }
    }
  }

  function applyAll() {
    var forms = document.querySelectorAll('cart-form');
    for (var i = 0; i < forms.length; i += 1) {
      applyGate(forms[i]);
    }
  }

  /* (ג) אכיפת-קליק כשהשער חסום — capture, לפני כל מאזין אחר. חל **רק** על
     מצב חסום: aria-disabled/disabled על כפתור ה-checkout, או כל כפתור-תשלום
     מהיר בתוך container שנושא .glow-checkout--blocked. במצב תקין המאזין יוצא
     מיד ואינו נוגע בזרימה הנייטיבית. */
  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || typeof target.closest !== 'function') return;
    var el = target.closest('.glow-checkout-btn, ' + DYNAMIC_SELECTORS.join(', '));
    if (!el) return;
    var attrBlocked = el.classList.contains('glow-checkout-btn')
      && (el.getAttribute('aria-disabled') === 'true' || el.disabled === true);
    if (!attrBlocked && !el.closest('.glow-checkout--blocked')) return;
    evt.preventDefault();
    evt.stopPropagation();
  }, true);

  /* on:cart:after-merge מבעבע (bubbles) מה-cart-form → נתפס ב-document.
     מריצים אחרי ה-merge כדי לקרוא את ה-state הטרי. */
  document.addEventListener('on:cart:after-merge', applyAll);
  document.addEventListener('on:cart:change', applyAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
})();
